import {Pipe, PipeTransform} from '@angular/core';
import {Nachweis} from '@wba/models/nachweis';
import {FileUtils} from '@wba/utils/file.utils';

@Pipe({
    name: 'uploadedFiles',
    standalone: false
})
export class UploadedFilePipe implements PipeTransform {
  transform(nachweise: Nachweis[]): Nachweis[] {
    return FileUtils.filterUploadedFiles(nachweise);
  }
}
